export const refundStatusLabel = (value) => {
  const status = String(value || "").trim().toLowerCase();
  if (status === "succeeded") return "Refunded";
  if (status === "pending" || status === "processing") return "Refund pending";
  if (status === "requires_action") return "Refund requires action";
  if (status === "failed") return "Refund failed";
  if (status === "canceled" || status === "cancelled") return "Refund canceled";
  return "Refund status unknown · Needs review";
};

const refundEventOrder = (event, index) => {
  const timestamp = Date.parse(event?.updated_at || event?.created_at || "");
  return [Number.isFinite(timestamp) ? timestamp : 0, Number(event?.id) || index];
};

export const summarizeRefundEvents = (events) => {
  const latestByRefund = new Map();
  (Array.isArray(events) ? events : []).forEach((event, index) => {
    if (String(event?.event_type || "") !== "charge.refunded") return;
    const refundId = String(event?.stripe_refund_id || "").trim();
    const key = refundId || `event:${Number(event?.id) || index}`;
    const order = refundEventOrder(event, index);
    const previous = latestByRefund.get(key);
    if (
      !previous ||
      order[0] > previous.order[0] ||
      (order[0] === previous.order[0] && order[1] >= previous.order[1])
    ) {
      latestByRefund.set(key, { event, order });
    }
  });

  let confirmedCents = 0;
  let openCents = 0;
  let needsReview = false;
  for (const { event } of latestByRefund.values()) {
    const amount = Math.max(0, Math.trunc(Number(event?.amount) || 0));
    const status = String(event?.status || "").trim().toLowerCase();
    if (status === "succeeded") {
      confirmedCents += amount;
    } else if (["pending", "processing", "requires_action"].includes(status)) {
      openCents += amount;
    } else if (!["failed", "canceled", "cancelled"].includes(status)) {
      // An unknown provider state must not be counted as refunded, but it must
      // block another refund until an operator or webhook proves the outcome.
      openCents += amount;
      needsReview = true;
    }
  }

  return {
    confirmedCents,
    openCents,
    hasOpenRefund: openCents > 0,
    needsReview,
  };
};
